var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.active)?_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"spinner loading-spinner"}),_c('div',{staticClass:"has-text-centered",domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }